import { useEffect, useState } from 'react';
import _ from 'lodash';
import { isAbsoluteEmpty } from 'ziphy-web-shared/basic/helpers';
import { composeDateComponentsToDateString } from 'ziphy-web-shared/basic/utils/time';
const useOnChange = ({ fields, isFull, onChange, alwaysReturnAsString }) => {
    const [invalidFields, setInvalidFields] = useState(null);
    const { day, month, year } = fields;
    useEffect(() => {
        const newInvalidFields = { month: false, day: false, year: false };
        if (!_.isNumber(year))
            newInvalidFields.year = true;
        if (isFull && !_.isNumber(month))
            newInvalidFields.month = true;
        if (isFull && !_.isNumber(day))
            newInvalidFields.day = true;
        if (Object.values(newInvalidFields).every((invalid) => !invalid)) {
            let resultDateComponents = {};
            _.forEach(fields, (value, unit) => {
                if (!isAbsoluteEmpty(value)) {
                    resultDateComponents[unit] = +value;
                }
            });
            onChange({
                value: composeDateComponentsToDateString(resultDateComponents, alwaysReturnAsString),
                isFull: Boolean(day),
            });
        }
        setInvalidFields(newInvalidFields);
    }, [day, month, year, isFull]);
    return invalidFields;
};
export default useOnChange;
